<template>
  <div>

    <base-header class="pb-6 bg-primary">

      <b-row class="align-items-center py-4">
        <b-col>
          <base-button @click="goBack()" type="uBind" class="mt-2 mt-sm-0 mb-4"><i
              class="fas fa-angle-left pr-3"></i>Back</base-button>
          <base-button @click="sendEmail()" type="uBind" style="float:right;" class="mt-2 mt-sm-0 mb-4"
            v-if="isShowSendToCustomer"><i class="fas fa-envelope pr-3"></i>Send to Customer</base-button>
          <br />
          <h6 class="h1 text-white header d-inline-block mb-0 fw-500" ref="topSection">
            {{ title }}
          </h6>
        </b-col>
      </b-row>
    </base-header>


    <div class="container-fluid mt--6" v-if="formModel != null">



      <edit-quote-form formMode="view" @emailCustomer="emailCustomer" @nextStep="nextStep" :editModel="formModel" />

    </div>
  </div>
</template>

<script>


import { GlobalStore } from "../../globalStore";
import { emailMethods } from "../../helpers/email";
import { toasts } from "../../helpers/toasts";
import { appFunctions } from "../../helpers/appFunctions";
import { quoteFormMethods } from "../../helpers/quoteForm";

import EditQuoteForm from "./EditQuoteForm.vue";

export default {
  name: "EditQuote",
  props: {
    title: {
      type: String,
      default: "Edit Quote"
    }
    // productType: {
    //   type: String,
    //   required: true,
    //   validator: value =>
    //     ["ride-protect", "mercurien-light-commercial"].includes(value)
    // }
  },
  data() {
    return {
      formModel: null,
      ubindQuoteId: null,
      jotFormLink: "",
      isShowSendToCustomer: false,
      isLoading: false,
    };
  },
  computed: {

    getJotFormId() {
      const jotformIds = {
        plantEquipment: `JotFormIFrame-${process.env.VUE_APP_PE_PROPOSAL_ID}`,
        motor: `JotFormIFrame-${process.env.VUE_APP_MOTOR_PROPOSAL_ID}`,
        otherAssets: `JotFormIFrame-${process.env.VUE_APP_OTHER_ASSETS_PROPOSAL_ID}`,
        property: `JotFormIFrame-${process.env.VUE_APP_PROPERTY_PROPOSAL_ID}`,

      }
      return jotformIds[this.$route.params.productName]
    },
    getTenant() {
      return GlobalStore.ubindClientInfo.tenantId;
    },
    getEnvironment() {
      return GlobalStore.ubindClientInfo.environment;
    }
  },
  methods: {
    async getCustomerInfo(customerId) {
      const customerObj = await appFunctions.crud_customer("get", {
        Customer_id: customerId
      });
      return customerObj.data;
    },
    async nextStep() {

    },
    async getjotFormLink() {
      const hasSubmissionId = this.$route.params.id;
      const quote = sessionStorage.getItem("jotformQuoteID");
      const quoteObj = JSON.parse(quote);

      if (hasSubmissionId != "NA") {
        this.isShowSendToCustomer = true
        this.jotFormLink = `https://www.jotform.com/edit/${quoteObj.Jotform_data_obj.submissionID}`
      }

      // if not submissionId, create a new jotform and customer infor with same quoteId to update exactly
      if (hasSubmissionId == "NA") {
        const customerObj = await this.getCustomerInfo(quoteObj.Customer_id);

        const params = `quoteId=${quoteObj.Jotform_quote_id}&quoteRef=${quoteObj.Quote_Ref_No}&firstName=${customerObj.Customer_contact_first_name}&lastName=${customerObj.Customer_contact_last_name}
        &customerEmail=${customerObj.Customer_contact_email}&customerPhoneNumber=${customerObj.Customer_contact_number}&businessABN=${customerObj.Customer_abn}&businessName=${quoteObj.Customer_insured_name}`;
        const jotformLinks = {
          plantEquipment: `${process.env.VUE_APP_PE_PROPOSAL_ID}?`,
          motor: `${process.env.VUE_APP_MOTOR_PROPOSAL_ID}?`,
          otherAssets: `${process.env.VUE_APP_OTHER_ASSETS_PROPOSAL_ID}?`,
          property: `${process.env.VUE_APP_PROPERTY_PROPOSAL_ID}?`,
          peLive: null
        }
        this.jotFormLink = "https://submit.jotform.com/" + jotformLinks[this.$route.params.productName] + params
      }
    },
    async emailCustomer() {

    },
    async sendEmail() {
      const mostRecentJotformQuoteId = JSON.parse(sessionStorage.getItem("jotformQuoteID"));
      let customerDetails;

      customerDetails = await appFunctions
        .crud_customerPolicy("getCombined", {
          policy_id: parseInt(mostRecentJotformQuoteId.Customer_policy_id)
        })


      await emailMethods.sendContinueQuoteEmail(
        GlobalStore.realmApp,
        customerDetails.data,
        "VIBS",
        this.$route.params.productName
      );

      toasts.success(
        `Email has been sent to ${customerDetails.data.Customer_contact_email}`
      );

      this.$router.push(`/products/ps-live/quoteEmailed`);
    },
    goBack() {
      this.$router.push(`/ps-live/quotes`);
    },
    scrollUp() {
      //location.hash = "#calcSection";
      const myEl = this.$refs.topSection;

      this.$smoothScroll({
        scrollTo: myEl,
        hash: "#topSection" // required if updateHistory is true
      });
    }
  },
  mounted() {
    //this.getjotFormLink();
    console.log('done');
    this.scrollUp();

    //console.log(this.$route.params.id);
    this.isLoading = true;

    appFunctions
      .crud_customerPolicy("getCombinedById", {
        id: this.$route.params.id
      })
      .then(resp => {
        this.formModel = resp.data;
        this.formModel.Customer_policy_status = "in_progress";

        this.formModel.quote_created_date = this.$moment(new Date()).format("YYYY-MM-DD");

        var policyObj = this.formModel.Data_obj.messageData.policy;

        this.formModel.privacyNotice1 = false;

        this.formModel.nswSdExemption = policyObj.commercialMotorSubproduct.generalMotorDetails.nswSdExemption == "YES" ? true : false;
        //this.formModel.privacyNotice2 = this.formModel.privacyNotice2 || false;
        //this.formModel.privacyNotice3 = this.formModel.privacyNotice3 || false;
        //this.formModel.privacyNotice4 = this.formModel.privacyNotice4 || false;
        //this.formModel.privacyNotice5 = this.formModel.privacyNotice5 || false;
        //this.formModel.privacyNotice6 = this.formModel.privacyNotice6 || false;
        this.formModel.dangerousGoods1 = policyObj.commercialMotorSubproduct.dangerousGoodsDisclosure.bulkDangerousGoodsCarried == "YES" ? true : false;

        this.formModel.acceptDOD = this.formModel.acceptDOD || false;
        //this.formModel.listOfDangerousGoods = [];
        //this.formModel.quote_created_date = format(new Date(this.formModel.quote_created_date),"yyyy-MM-dd");
        // document.location.href =
        //   "/ps-live/continueQuote/" + quoteId;
        console.log("data:")
        console.log(this.formModel)
        this.isLoading = false;
      });
  },
  components: {
    EditQuoteForm
  },
};
</script>

<style lang="scss" scoped>
.top-padding {
  padding-top: 0px !important;
}

.ubind-product {
  margin: 0px 15px 0px 15px;
}

.container-fluid {
  padding-left: 0px;
  padding-left: 0px;
  padding-right: 0px;
}
</style>
